import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Footer.css';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaInstagram, FaTwitter, FaFacebook } from 'react-icons/fa';

const Footer = () => {
  const scrollToProducts = (e) => {
    // If we're on the home page, scroll to products section
    if (window.location.pathname === '/') {
      e.preventDefault();
      const productsSection = document.getElementById('products-section');
      if (productsSection) {
        productsSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    // If we're on another page, let the Link handle navigation to home
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/" onClick={scrollToTop}>Home</Link>
            </li>
            <li>
              <Link 
                to="/" 
                onClick={scrollToProducts}
              >
                Products
              </Link>
            </li>
            <li>
              <Link to="/deals">Hot Deals</Link>
            </li>
            <li>
              <Link to="/faq">FAQ</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact Us</h3>
          <ul className="contact-info">
            <li>
              <FaPhone className="icon" />
              <a href="tel:2022099605">(202) 209-9605</a>
            </li>
            <li>
              <FaEnvelope className="icon" />
              <a href="mailto:potcitydc@gmail.com">potcitydc@gmail.com</a>
            </li>
            <li>
              <FaMapMarkerAlt className="icon" />
              <span>Washington, DC</span>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Hours</h3>
          <ul className="hours-info">
            <li>
              <span className="day">Monday - Saturday:</span>
              <span className="time">9am - 10pm</span>
            </li>
            <li>
              <span className="day">Sunday:</span>
              <span className="time">9am - 9pm</span>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-links">
            <a href="https://instagram.com" aria-label="Instagram">
              <FaInstagram className="social-icon" />
            </a>
            <a href="https://twitter.com" aria-label="Twitter">
              <FaTwitter className="social-icon" />
            </a>
            <a href="https://facebook.com" aria-label="Facebook">
              <FaFacebook className="social-icon" />
            </a>
          </div>
          <div className="newsletter">
            <h4>Stay Updated</h4>
            <form className="newsletter-form">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="newsletter-input"
                required 
              />
              <button type="submit" className="newsletter-btn">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {new Date().getFullYear()} PotCityDC. All rights reserved.</p>
          <div className="legal-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="/compliance">Compliance</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;